__turbopack_context__.v({
  "actions": "ActivityDetail-module__RhqY-a__actions",
  "agent": "ActivityDetail-module__RhqY-a__agent",
  "badge": "ActivityDetail-module__RhqY-a__badge",
  "bodyLayout": "ActivityDetail-module__RhqY-a__bodyLayout",
  "carouselDots": "ActivityDetail-module__RhqY-a__carouselDots",
  "contactCard": "ActivityDetail-module__RhqY-a__contactCard",
  "contactIcon": "ActivityDetail-module__RhqY-a__contactIcon",
  "contactRow": "ActivityDetail-module__RhqY-a__contactRow",
  "desktopContactCards": "ActivityDetail-module__RhqY-a__desktopContactCards",
  "desktopSidebarPrice": "ActivityDetail-module__RhqY-a__desktopSidebarPrice",
  "durationBadge": "ActivityDetail-module__RhqY-a__durationBadge",
  "enquiryBtn": "ActivityDetail-module__RhqY-a__enquiryBtn",
  "errorMsg": "ActivityDetail-module__RhqY-a__errorMsg",
  "galleryDesktop": "ActivityDetail-module__RhqY-a__galleryDesktop",
  "galleryMobile": "ActivityDetail-module__RhqY-a__galleryMobile",
  "galleryNav": "ActivityDetail-module__RhqY-a__galleryNav",
  "galleryNavNext": "ActivityDetail-module__RhqY-a__galleryNavNext",
  "galleryNavPrev": "ActivityDetail-module__RhqY-a__galleryNavPrev",
  "galleryShell": "ActivityDetail-module__RhqY-a__galleryShell",
  "gallerySliderSlide": "ActivityDetail-module__RhqY-a__gallerySliderSlide",
  "gallerySliderWrap": "ActivityDetail-module__RhqY-a__gallerySliderWrap",
  "headerFooter": "ActivityDetail-module__RhqY-a__headerFooter",
  "heroActions": "ActivityDetail-module__RhqY-a__heroActions",
  "heroDesktop": "ActivityDetail-module__RhqY-a__heroDesktop",
  "heroMobile": "ActivityDetail-module__RhqY-a__heroMobile",
  "heroTitleRow": "ActivityDetail-module__RhqY-a__heroTitleRow",
  "heroTopRow": "ActivityDetail-module__RhqY-a__heroTopRow",
  "iconBtn": "ActivityDetail-module__RhqY-a__iconBtn",
  "includeIcon": "ActivityDetail-module__RhqY-a__includeIcon",
  "includeItem": "ActivityDetail-module__RhqY-a__includeItem",
  "includesBox": "ActivityDetail-module__RhqY-a__includesBox",
  "includesGrid": "ActivityDetail-module__RhqY-a__includesGrid",
  "includesTitle": "ActivityDetail-module__RhqY-a__includesTitle",
  "location": "ActivityDetail-module__RhqY-a__location",
  "mainCol": "ActivityDetail-module__RhqY-a__mainCol",
  "mainTile": "ActivityDetail-module__RhqY-a__mainTile",
  "mobileContactCards": "ActivityDetail-module__RhqY-a__mobileContactCards",
  "mobileEnquiryBtn": "ActivityDetail-module__RhqY-a__mobileEnquiryBtn",
  "mobileIncludes": "ActivityDetail-module__RhqY-a__mobileIncludes",
  "mobilePriceActions": "ActivityDetail-module__RhqY-a__mobilePriceActions",
  "mobilePriceBar": "ActivityDetail-module__RhqY-a__mobilePriceBar",
  "mobilePriceBarHidden": "ActivityDetail-module__RhqY-a__mobilePriceBarHidden",
  "mobilePriceInfo": "ActivityDetail-module__RhqY-a__mobilePriceInfo",
  "mobilePriceNote": "ActivityDetail-module__RhqY-a__mobilePriceNote",
  "mobilePriceNow": "ActivityDetail-module__RhqY-a__mobilePriceNow",
  "mobilePriceOld": "ActivityDetail-module__RhqY-a__mobilePriceOld",
  "mobileProceedBtn": "ActivityDetail-module__RhqY-a__mobileProceedBtn",
  "offerTag": "ActivityDetail-module__RhqY-a__offerTag",
  "page": "ActivityDetail-module__RhqY-a__page",
  "priceCard": "ActivityDetail-module__RhqY-a__priceCard",
  "priceNote": "ActivityDetail-module__RhqY-a__priceNote",
  "priceNow": "ActivityDetail-module__RhqY-a__priceNow",
  "priceOld": "ActivityDetail-module__RhqY-a__priceOld",
  "priceRow": "ActivityDetail-module__RhqY-a__priceRow",
  "priceTag": "ActivityDetail-module__RhqY-a__priceTag",
  "pricing": "ActivityDetail-module__RhqY-a__pricing",
  "proceedBtn": "ActivityDetail-module__RhqY-a__proceedBtn",
  "ratingBadge": "ActivityDetail-module__RhqY-a__ratingBadge",
  "ratingCol": "ActivityDetail-module__RhqY-a__ratingCol",
  "reviewLink": "ActivityDetail-module__RhqY-a__reviewLink",
  "saveTag": "ActivityDetail-module__RhqY-a__saveTag",
  "sideCol": "ActivityDetail-module__RhqY-a__sideCol",
  "sidebar": "ActivityDetail-module__RhqY-a__sidebar",
  "stateMsg": "ActivityDetail-module__RhqY-a__stateMsg",
  "stickyPriceTitle": "ActivityDetail-module__RhqY-a__stickyPriceTitle",
  "tile": "ActivityDetail-module__RhqY-a__tile",
  "title": "ActivityDetail-module__RhqY-a__title",
  "titleBlock": "ActivityDetail-module__RhqY-a__titleBlock",
  "titleLine": "ActivityDetail-module__RhqY-a__titleLine",
  "whatsapp": "ActivityDetail-module__RhqY-a__whatsapp",
});
